import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { authService } from '../../services/auth.service';
import type { Profile } from '../../types';
import { useAuthStore } from '../../stores/useAuthStore';

export const useProfile = () => {
    const { isAuthenticated, client } = useAuthStore();
    return useQuery({
        queryKey: ['profile'],
        queryFn: authService.getProfile,
        retry: 1,
        enabled: isAuthenticated && !!client,
    });
};

export const useUpdateProfile = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: Partial<Profile>) => authService.updateProfile(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['profile'] });
        },
    });
};

export const useGoogleLogin = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (idToken: string) => authService.loginWithGoogle(idToken),
        onSuccess: () => {
            // Upon successful login, we might want to refetch profile
            queryClient.invalidateQueries({ queryKey: ['profile'] });
            queryClient.invalidateQueries({ queryKey: ['orders'] });
        },
    });
};
